import { useIsDesktopBrowser } from "./useIsDesktopBrowser";
import { useLocalStorageState } from "./useLocalStorageState";

export function useShowComposeInfoPanel() {
  const isDesktop = useIsDesktopBrowser();
  return useLocalStorageState(`thread`, `showComposeInfoPanel`, isDesktop);
}
